module.exports = __webpack_public_path__ + "img/after-subdomain-dashboard-en.1ad367f.png";